<template>
  <Dialog
    v-model="dialogDeleteGrammar"
    icon="fas fa-trash-alt"
    :title="'確認'"
    textNo="いいえ"
    textYes="はい"
    colorTextYes="red--text"
  >
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn small color @click="dialogDeleteGrammar = false">{{$t('CANCEL')}}</v-btn>
      <v-btn
        :loading="loadingDeleteGrammar"
        color="error"
        small
        @click="handleDeleteGrammar(item.Id)"
      >{{$t('OK')}}</v-btn>
    </template>
  </Dialog>
</template>

<script>
import { deleteGrammar } from "@/api/Grammar.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialogDeleteGrammar: false,
      loadingDeleteGrammar: false,
    };
  },
  methods: {
    async handleDeleteGrammar() {
      this.loadingDeleteGrammar = true;
      let params = {
        id: this.item.Id,
        section: "",
      };
      await deleteGrammar(params)
        .then(() => {
          this.$emit("resetList");
          this.dialogDeleteGrammar = false;
        })
        .catch(() => {});
      this.loadingDeleteGrammar = false;
    },
    handleCancel() {
      //   this.$emit("resetList");
      this.loadingDeleteGrammar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>